import { render, staticRenderFns } from "./child-small.vue?vue&type=template&id=4adaca68&scoped=true&"
import script from "./child-small.vue?vue&type=script&lang=ts&"
export * from "./child-small.vue?vue&type=script&lang=ts&"
import style0 from "./child-small.vue?vue&type=style&index=0&id=4adaca68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adaca68",
  null
  
)

export default component.exports